import React, { memo } from 'react'
import { LoadingSpinner } from '@paypalcorp/pp-react'

const Spinner = memo(() => {
  return (
    <section style={{ minHeight: '500px' }}>
      <div className="requestForm-spinner">
        <LoadingSpinner screenReaderText="loading" size="lg" />
      </div>
    </section>
  )
})
Spinner.displayName = 'Spinner'

export default Spinner
